import React from 'react';
import { useParams } from 'react-router-dom';

const CoursePage = ({ title }) => {
  const { courseId } = useParams();
  
  // Sample content for each course
  const courseContent = {
    'our-courses': {
      description: 'Explore our wide range of academic programs designed to provide quality education and practical skills for your future career.'
    },
    'foundation-programmes': {
      description: 'Our foundation programs are designed to prepare students for undergraduate studies with essential academic skills and subject knowledge.'
    },
    'business-management': {
      description: 'Develop business acumen and leadership skills with our comprehensive business and management programs.'
    },
    'computing-it': {
      description: 'Stay ahead in the digital age with our cutting-edge computing and information technology programs.'
    },
    'law': {
      description: 'Pursue a career in law with our comprehensive legal education programs.'
    },
    'health-social-care': {
      description: 'Make a difference in people\'s lives with our health and social care programs.'
    },
    'tourism-hospitality': {
      description: 'Join the dynamic world of tourism and hospitality with our industry-focused programs.'
    },
    'short-courses': {
      description: 'Enhance your skills with our range of short courses designed for professional development.'
    }
  };

  const content = courseContent[courseId] || {
    description: 'Course information coming soon.'
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6 bg-gray-50">
            <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <div className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <p className="text-lg text-gray-700">
                  {content.description}
                </p>
                <div className="mt-6">
                  <p className="text-gray-600">
                    This is a sample page for {title}. More content will be added here soon.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoursePage;
